<script lang="ts">
	export let category: string | null | undefined;
	export let imageSrc: string;
	export let sideDecorationImageSrc: string;
	export let title: string;
	export let subtitle: string;
</script>

<div class="flex flex-col relative min-h-[23.75rem] min-w-[15rem] max-w-[15rem]">
	{#if category}
		<div
			class="absolute top-2 left-2 text-xs font-bold bg-white border border-black rounded-3xl py-[0.125rem] px-2 "
		>
			{category}
		</div>
	{/if}
	<img
		class="object-cover h-full rounded-t-lg"
		src={imageSrc}
		alt="The background of the info card. Likely the portait of a person who is a teacher on the platform."
	/>
	<div class="flex flex-row bg-black text-white gap-4 rounded-br-lg min-h-[5.125rem]">
		<div class="flex flex-row min-w-[12.4%] bg-white pr-[0.125rem]">
			<img
				class="rounded-bl-lg"
				src={sideDecorationImageSrc}
				alt="A colourful small side decoration on an info card."
			/>
		</div>
		<div class="flex flex-col justify-center items-start h-full">
			<div class="text-sm font-bold">{title}</div>
			<div class="text-xs pr-11">{@html subtitle}</div>
		</div>
	</div>
</div>
